export function isDeinitable(service) {
    if (!service) {
        throw new Error('Service is undefined');
    }
    return typeof service.deinit === 'function';
}
export function canBlockDeinit(service) {
    if (!service) {
        throw new Error('Service is undefined');
    }
    return typeof service.blockDeinit === 'function';
}
